import * as z from "zod";
import { automationDetailSchema } from "./common";

export const getAutomation = {
  name: "getAutomation" as const,
  input: z.object({ id: z.string() }),
  output: z.object({ automation: automationDetailSchema }),
};
